<template>
  <error-boundary>
    <router-view />
    <q-loader :is-loading="isLoading" />
    <offline @detected-condition="handleConnectivityChange" />
    <not-supported-browser-modal />
    <microneedling-validation-modals />
    <v-modal-target name="root-modal" />
  </error-boundary>
</template>

<script>
import '@/assets/scss/styles.scss';

import { mapGetters, mapActions } from 'vuex';
import offline from 'v-offline';

import { VModalTarget } from '@arfedulov/vue2-modal';
import QLoader from '@/modules/questionnaire/components/common/Loader';
import NotSupportedBrowserModal from '@/components/NotSupportedBrowserModal';
import MicroneedlingValidationModals from '@/modules/dashboard/components/microneedling/MicroneedlingValidationModals';
import ErrorBoundary from '@/components/ErrorBoundary';

import { screenHeightMixin } from '@/modules/questionnaire/mixins/screenHeightMixin';

import { isIE } from '@/utils';
import { errorObserver } from '@/services/errorObserver';
import { ALMA_TERRITORIES } from '@/modules/dashboard/constants/alma-countries';
import { LocalStorageService } from '@/services/LocalStorageService';

import rootTypes, { types } from '@/store/types';

export default {
  name: 'App',
  components: {
    NotSupportedBrowserModal,
    QLoader,
    offline,
    MicroneedlingValidationModals,
    ErrorBoundary,
    VModalTarget
  },
  mixins: [screenHeightMixin],
  created() {
    this.fetchCountryCode();
  },
  mounted() {
    if (isIE()) {
      this.$modal.show('not-supported-browser-modal');
    }
  },
  watch: {
    currentTerritoryStatus: {
      immediate: true,
      handler(newValue) {
        this.updateFavicon(newValue);
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: types.getters.GET_LOADING,
      isAlmaTerritory: rootTypes.getters.IS_ALMA_TERRITORY,
      doctorCountry: rootTypes.getters.GET_USER_COUNTRY
    }),
    isDoctorInAlmaTerritory() {
      return ALMA_TERRITORIES.includes(this.doctorCountry);
    },
    isAuthenticated() {
      return !!LocalStorageService.getDashboardToken();
    },

    currentTerritoryStatus() {
      return this.isAuthenticated ? this.isDoctorInAlmaTerritory : this.isAlmaTerritory;
    }
  },
  methods: {
    ...mapActions({
      fetchCountryCode: rootTypes.actions.FETCH_COUNTRY_CODE
    }),
    handleConnectivityChange(isOnline) {
      if (!isOnline) {
        errorObserver.dispatchError(new NetworkError());
      }
    },
    updateFavicon(isAlma) {
      const faviconId = 'favicon-link';
      const existingFavicon = document.getElementById(faviconId);

      if (existingFavicon) {
        existingFavicon.remove();
      }

      const favicon = document.createElement('link');
      favicon.id = faviconId;
      favicon.rel = 'icon';
      favicon.type = 'image/png';
      const timestamp = Date.now(); // cache buster
      favicon.href = isAlma ? `/alma-favicon.ico?v=${timestamp}` : `/favicon.png?v=${timestamp}`;
      document.head.appendChild(favicon);
    }
  }
};
</script>
